import PropTypes from 'prop-types';
import React from 'react';
import request from 'superagent';
import { Link } from 'react-router-dom';
import objectAssign from 'object-assign';
import Media from 'react-media';

import JawsComponent from 'components/JawsComponent';

import jawsConnect from 'utils/jawsConnect';
import formatNumber from 'utils/formatNumber';
import decimalPlaces from 'utils/decimalPlaces';

if (process.env.NODE_ENV !== 'test') {
  require('./OrderDepth.scss');
}

class Row extends React.Component {
  render() {
    const values = this.props.item.values;
    let bid = values.percentOfMax.bid;
    let ask = values.percentOfMax.ask;
    if (bid > 100) {
      bid = 100;
    }
    if (ask > 100) {
      ask = 100;
    }
    const barStyle = {
      bid: {
        width: bid + '%',
      },
      ask: {
        width: ask + '%',
      },
    };

    return (
      <tr>
        {!!this.props.showSum && !!this.props.hasLevel2 && (
          <td className="BIDNBR">
            <span>{formatNumber(values.BIDNBR, 0)}</span>
          </td>
        )}
        <td className="BIDVOL">
          <span>{formatNumber(values.BIDVOL, 0)}</span>
        </td>
        <td className="bar">
          <span className="bar-bid" style={barStyle.bid}></span>
        </td>
        <td>
          <span className="BID">
            {formatNumber(values.BID, decimalPlaces(values.BID))}
          </span>
        </td>
        <td>
          <span className="ASK">
            {formatNumber(values.ASK, decimalPlaces(values.ASK))}
          </span>
        </td>
        <td className="bar">
          <span className="bar-ask" style={barStyle.ask}></span>
        </td>
        <td>
          <span className="ASKVOL">{formatNumber(values.ASKVOL, 0)}</span>
        </td>
        {!!this.props.showSum && !!this.props.hasLevel2 && (
          <td className="ASKNBR">
            <span>{formatNumber(values.ASKNBR, 0)}</span>
          </td>
        )}
      </tr>
    );
  }
}

class OrderDepth extends JawsComponent {
  spec = {};
  state = {};

  static propTypes = {
    sector: PropTypes.string,
    itemSector: PropTypes.string.isRequired,
    levels: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  static defaultProps = {
    levels: 5,
  };

  componentDidMount() {
    this.getInstrumentType(this.props).then(() => {
      this.setLevelTwoPermission(this.props);
    });
  }

  componentWillReceiveProps(newProps) {
    if (!this.props.user.equals(newProps.user)) {
      this.setLevelTwoPermission(newProps);
    }

    // HB-563
    // When navigating to this page, this component needs
    // to clear it's state
    if (!newProps.itemSector) {
      this.actions.deleteAllItems(this.componentId);
      this.unsubscribe();
    } else if (
      this.props.itemSector !== newProps.itemSector ||
      this.props.levels !== newProps.levels
    ) {
      this.setLevelTwoPermission(newProps);
    }
  }

  getInstrumentType = newProps => {
    return request
      .get(`/server/domain/?itemSector=${newProps.itemSector}`)
      .then(response => {
        this.setState({ instrumentType: response.body[0].type });
      });
  };

  setLevelTwoPermission(newProps) {
    const itemSectorArray = this.props.itemSector.split('.');
    const sector = itemSectorArray[itemSectorArray.length - 1];

    if ('SSE' === sector) {
      this.setState(
        {
          hasLevel2:
            this.props.user &&
            this.props.user.has('shiro') &&
            this.props.user
              .get('shiro')
              .check('source:REALTIME:feed.sse.orders.*'),
        },
        () => {
          this.updateSpec(newProps);
        },
      );
    } else {
      this.setState(
        {
          hasLevel2:
            this.props.user &&
            this.props.user.has('shiro') &&
            this.props.user
              .get('shiro')
              .check('source:REALTIME:feed.ob.orders.*'),
        },
        () => {
          this.updateSpec(newProps);
        },
      );
    }
  }

  updateSpec(fromProps) {
    const { itemSector, levels: limit } = fromProps;
    // HB-1407
    const isEtn = this.state.instrumentType === 'ETNS';

    if (this.state.hasLevel2 && !isEtn) {
      this.spec = objectAssign({}, this.spec, {
        columns: 'BIDNBR, BIDVOL, BID, ASK, ASKVOL, ASKNBR, level',
        convert: 'levels',
        dataSet: 'orders',
        limit,
      });
    } else {
      this.spec = objectAssign({}, this.spec, {
        columns: 'BID_VOL as BIDVOL, ASK_VOL as ASKVOL, BID, ASK',
      });
    }

    this.spec = objectAssign({}, this.spec, {
      itemSector,
    });

    this.resubscribe();
  }

  render() {
    // calculate bar widths
    const { items } = this.props;

    const {
      maxVolume,
      minPrice,
      sumAskVol,
      sumBidVol,
      sumNumAsk,
      sumNumBid,
    } = items.reduce(
      (a, b) => {
        return {
          maxVolume:
            Math.max(b.values.BIDVOL, b.values.ASKVOL, a.maxVolume) ||
            a.maxVolume,
          minPrice:
            Math.min(b.values.BID, b.values.ASK, a.minPrice) || a.minPrice,
          sumNumAsk: a.sumNumAsk + b.values.ASKNBR || a.sumNumAsk,
          sumNumBid: a.sumNumBid + b.values.BIDNBR || a.sumNumBid,
          sumBidVol: a.sumBidVol + b.values.BIDVOL || a.sumBidVol,
          sumAskVol: a.sumAskVol + b.values.ASKVOL || a.sumAskVol,
        };
      },
      {
        minPrice: Number.MAX_VALUE,
        maxVolume: 0,
        sumAskVol: 0,
        sumBidVol: 0,
        sumNumAsk: 0,
        sumNumBid: 0,
      },
    );

    return (
      <div className="OrderDepth">
        <Media query="(max-width: 768px)">
          {small => (
            <table>
              <thead>
                <tr>
                  {!!this.props.showSum && !!this.state.hasLevel2 && (
                    <th className="BIDNBR number number-left">
                      {small ? 'Ant' : 'Antall'}
                    </th>
                  )}
                  <th className="BIDVOL number number-left">Volum</th>
                  <th className="bar number"></th>
                  <th className="number">Kjøp</th>
                  <th className="number number-left">Selg</th>
                  <th className="bar"></th>
                  <th className="ASKVOL number">Volum</th>
                  {!!this.props.showSum && !!this.state.hasLevel2 && (
                    <th className="ASKNBR number">
                      {small ? 'Ant' : 'Antall'}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {items
                  .sortBy(item => item.values.level)
                  .toArray()
                  .map(item => {
                    item.values.minPrice = minPrice;
                    item.values.percentOfMax = {
                      ask: Math.max(
                        item.values.ASKVOL
                          ? (item.values.ASKVOL / maxVolume) * 100
                          : 0,
                        3,
                      ),
                      bid: Math.max(
                        item.values.BIDVOL
                          ? (item.values.BIDVOL / maxVolume) * 100
                          : 0,
                        3,
                      ),
                    };

                    return (
                      <Row
                        item={item}
                        key={item.key}
                        showSum={this.props.showSum}
                        hasLevel2={this.state.hasLevel2}
                      />
                    );
                  })}
              </tbody>
              {!!this.props.showSum && !!this.state.hasLevel2 && (
                <tfoot>
                  <tr>
                    <td className="BIDNBR">{formatNumber(sumNumBid, 0)}</td>
                    <td className="BIDVOL">{formatNumber(sumBidVol, 0)}</td>
                    <td />
                    <td />
                    <td />
                    <td />
                    <td className="ASKVOL">{formatNumber(sumAskVol, 0)}</td>
                    <td className="ASKNBR">{formatNumber(sumNumAsk, 0)}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          )}
        </Media>
        {!this.state.hasLevel2 && (
          <p className="navigation">
            <Link to="/account">
              Bestill fullstendig ordredybde
              <i className="fa fa-angle-right" />
            </Link>
          </p>
        )}
      </div>
    );
  }
}

export { OrderDepth };
export default jawsConnect(OrderDepth);
